import { ONE_MINUTE, ONE_SECOND } from '@lucidlink/uicore';
export const DEFAULT_STREAM_STALL_CHECK_INTERVAL = 10 * ONE_SECOND;
export const DEFAULT_STREAM_RESPONSE_DEADLINE = 2 * ONE_MINUTE;
export const SwChannelMessageTypes = {
    CHUNK: 'CHUNK',
    END: 'END',
    PING: 'PING',
};
export { ONE_HOUR as MAX_STREAM_RESPONSE_TIME_CEILING } from '@lucidlink/uicore';
